import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Badge} from "@material-tailwind/react";
import {useNavigate} from "react-router-dom";
import PopupProduct from "../pop up not used/pop-product";
import PopupCart from "../pop up not used/pop-cart";
import AuthService from "../services/auth/auth_service";
import PopConfirm from "../pop up not used/PopConfirm";



export default function SmallHeader({menuItems, activeMenu}) {

    console.log('AAA',menuItems)
const navigate = useNavigate()

      const dd =()=>{
    const themeButton = document.getElementById('theme-button')
    const darkTheme = 'dark-theme'
    const iconTheme = 'bx-sun'

// Previously selected topic (if user selected)
const selectedTheme = localStorage.getItem('selected-theme')
const selectedIcon = localStorage.getItem('selected-icon')

// We obtain the current theme that the interface has by validating the dark-theme class
const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? 'dark' : 'light'
const getCurrentIcon = () => themeButton.classList.contains(iconTheme) ? 'bx-moon' : 'bx-sun'

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === 'dark' ? 'add' : 'remove'](darkTheme)
  themeButton.classList[selectedIcon === 'bx-moon' ? 'add' : 'remove'](iconTheme)
}


 document.body.classList.toggle(darkTheme)
    themeButton.classList.toggle(iconTheme)
    // We save the theme and the current icon that the user chose
    localStorage.setItem('selected-theme', getCurrentTheme())
    localStorage.setItem('selected-icon', getCurrentIcon())
  }

   const [activeMenu1, setActiveMenu1] = useState('Home');


     const handleActiveChange = (menuName) => {
console.log(menuName)

     setActiveMenu1(menuName);

  };


      const [cartCount, setCartCount ] = useState(0)
     useEffect(() => {
    AuthService.loadCartListbyUserId(localStorage.getItem('uuid'))
      .then((response) => {
        setCartCount(response.data.cart_count);
        localStorage.setItem('cart_count', response.data.cart_count)
      })
      .catch((error) => {
        console.error('Error loading cart:', error);
      });
  }, [cartCount]);


         const cartCounter = (newTotalPrice) => {
    setCartCount(newTotalPrice);
  };


    return(
        <div   onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}>
  <header className="header sm:hidden" id="header">
    <nav className="nav container">
      <i className='bx bxs-watch nav__logo-icon'>
        <div  className="nav__logo " style={{ marginLeft: '4px' }}>
          Maokoto OG
        </div>
      </i>

      <div className="nav__menuT" id="nav-menu">

        <ul className="nav__listT " >
          {menuItems.map((menuItem) => (
            <li  className="nav__item" key={menuItem.name} onClick={()=>{handleActiveChange(menuItem.name); PopupProduct.hide(); PopConfirm.hide()}}>
              <div

                onClick={() => { navigate(menuItem.path); }}
                className={`nav__linkT ${
                  activeMenu1 === menuItem.name ? 'active-link' : ''
                }`}
              >
                <i
                  className={`bx bx-${menuItem.icon.toLowerCase()} nav__icon ${
                    menuItem.icon === 'Package' ? 'text-blue-500 bx-fade-up' : ''
                  }`}
                ></i>
                {menuItem.name === 'Kikapu' ? (
                  <span className="nav__name" onClick={()=>handleActiveChange(menuItem.name)}>
                    <Badge
                      style={{
                        marginTop: '-19px',
                        marginLeft: '30px',
                        borderRadius: '100%',
                        fontSize: '11px',
                        padding: '2px',
                        fontWeight: 'bold',
                      }}
                      content={<div style={{}}>{localStorage.getItem("cart_count")}</div>}
                      className="bg-gradient-to-tr from-green-400 bx-burst text-white to-green-600 border-2 border-white shadow-lg shadow-black/20"
                    >
                      {menuItem.name}
                    </Badge>
                  </span>
                ) : (
                  <span
                    className={`nav__name ${
                      menuItem.name === 'Package' ? 'bx-burst ' : ''
                    }`}
                  >
                    {menuItem.name}
                  </span>
                )}
              </div>
            </li>
          ))}
          <li className="nav__item   flex items-center justify-center"> <i className='bx bx-moon  ' onClick={() => dd()} id="theme-button" style={{ fontSize: '24px', marginTop:'6px' }}></i> </li>
        </ul>

      </div>

      <div className="nav__btns">
        <i
          className='bx bx-moon'
          style={{ fontSize: '24px' }}
          onClick={() => dd()}
          id="theme-button"
        ></i>

        <div className="nav__shop" id="cart-shop">
          <i className='bx bx-shopping-bag'></i>
        </div>

        <div onClick={()=>localStorage.clear()} className="nav__toggle" id="nav-toggle">
          <i className='bx bx-grid-alt'></i>
        </div>
      </div>
    </nav>
  </header>
</div>
    )
}
